var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrePaidLob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 23,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.571289,
    y: 0.575012,
    width: 14.8571,
    height: 21.85,
    rx: 1.5,
    stroke: "#39284F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 3.48345H10.2858H5.71436Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 3.48345H10.2858",
    stroke: "#39264F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 17.2499C11.1558 17.2499 13.7142 14.6756 13.7142 11.4999C13.7142 8.3243 11.1558 5.74994 7.99993 5.74994C4.84402 5.74994 2.28564 8.3243 2.28564 11.4999C2.28564 14.6756 4.84402 17.2499 7.99993 17.2499Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5289H15.1874H0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5289H15.1874",
    stroke: "#39284F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71432 21.275C8.18771 21.275 8.57146 20.8888 8.57146 20.4125C8.57146 19.9361 8.18771 19.55 7.71432 19.55C7.24093 19.55 6.85718 19.9361 6.85718 20.4125C6.85718 20.8888 7.24093 21.275 7.71432 21.275Z",
    fill: "#39264F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57129 6.80053H5.72786C7.13799 6.80053 7.99986 7.2571 8.22673 8.17471H4.57129V8.96587H8.27121C8.16 10.0558 7.21695 10.7563 5.46652 10.7563H4.57685V11.7411C6.10931 13.3212 7.28368 14.6942 8.56147 16.1814H10.1062C8.74496 14.5689 7.3782 12.953 6.10264 11.6717C8.17779 11.609 9.4934 10.5818 9.65576 8.98602H11.3995V8.18255H9.6313C9.55806 7.54067 9.22542 6.95745 8.7116 6.57001H11.3884V5.78668H4.57129V6.80053Z",
    fill: "#E40000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57129 8.54743H11.4284",
    stroke: "#E40000",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57129 6.30946H11.4284",
    stroke: "#E40000",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrePaidLob);
export default __webpack_public_path__ + "static/media/pre-paid-lob.56abe2781bcb870ad639fc1bf5a06133.svg";
export { ForwardRef as ReactComponent };